import swal from "sweetalert2";

const Toast = swal.mixin({
    toast: true,
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', swal.stopTimer)
        toast.addEventListener('mouseleave', swal.resumeTimer)
    }
})



const toast = {
    error: (title, type = 'error', position = 'center-end') => {
        return Toast.fire({
            icon: type,
            title: title,
            position
        });
    },

    success: (title, type = 'success', position = 'center-end') => {
        return Toast.fire({
            icon: type,
            title: title,
            position
        });
    }
};

export default toast;